// Copyright (c) 2020 Deere & Company

import './app-greeting.scss';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';

export class AppGreeting extends Component {

    state = {
        userDetails: ''
    };

    UNSAFE_componentWillReceiveProps = newProps => {

        if ( newProps.userDetails !== this.state.userDetails ) {

            this.setState( { userDetails: newProps.userDetails } );

        }

    }

    logout = () => {

        this.props.authState.logout( '/' );

    }

    render () {

        return (
            <div className="app-greeting">
                <span className="hi">Hi {this.props.userDetails}</span>
            </div>
        );

    }

}

AppGreeting.propTypes = {
    userDetails: PropTypes.string.isRequired,
    authState: PropTypes.object.isRequired
};

const mapStateToProps = state => ( {
    userDetails: state.oktaState.oktaState.userFirstName
} );

export default connect(
    mapStateToProps,
)( withOktaAuth( AppGreeting ) );
